const VERSION = '3.10.1';
export default VERSION;
